// @flow
import { loadModularUI } from "../_modularui/ModularUIActions";
import { HTTP_METHODS } from "../../constants/Constants";

import FormModel from "../../models/form/FormModel";

import type { AttributeType, ModularUIModel } from "../../models/types";
import type { ThunkAction } from "../types";

/**
 */
export const autoupdateFormObject = (
  form: FormModel,
  attribute: AttributeType,
): ThunkAction<> | null => {
  // As long as we have form objects,
  // and the current attribute is not found in the current form object, go back.
  // When a form has a result, the current form object is null
  while (
    form.allObjects.length > 0 &&
    (!form.currentFormObject ||
      !form.currentFormObject.hasAttributeByKey(attribute.key))
  ) {
    form.setPreviousObject();
  }

  if (form.isChanged()) {
    return loadModularUI(
      form.connectKey,
      form.selfhref.setParameter("commit", "false"),
      {
        method: HTTP_METHODS.POST,
        data: form.formdata,
        updateHandler: (newModel: ModularUIModel): ModularUIModel => {
          if (newModel instanceof FormModel) {
            const clonedModel: FormModel = form.clone();
            clonedModel.updateCurrentFormObject(newModel);
            return clonedModel;
          }
          return newModel;
        },
      },
    );
  }

  return null;
};
